window.Products.HomeDecor.BedPillowSleeveKing = function() {};
window.Products.HomeDecor.BedPillowSleeveKing.inherits(window.Products.HomeDecor.BedPillowSleeve);
window.Products.HomeDecor.BedPillowSleeveKing.has_3d = true;
window.Products.HomeDecor.BedPillowSleeveKing.id = '90-king';
window.Products.HomeDecor.BedPillowSleeveKing.saveId = 90;
window.Products.HomeDecor.BedPillowSleeveKing.slug = 'bed-pillow-sleeve-king';
window.Products.HomeDecor.BedPillowSleeveKing.dpi = 150;